import { IUnitModuleNode, UnitModuleNode } from "./unitModuleNode";

export interface IModuleUnits {
    unitModuleNode: IUnitModuleNode;
}

export class ModuleUnits implements IModuleUnits {
    unitModuleNode: UnitModuleNode;

    constructor();
    constructor(obj: IModuleUnits);
    constructor(obj?: any) {
        this.unitModuleNode = new UnitModuleNode(obj ? obj.unitModuleNode : null);
    }
}